// extracted by mini-css-extract-plugin
module.exports = {"title":"title-d9d7b301","top":"top-489f2057"};